/**
 * Global toast API (shadcn-style Toaster).
 * Use toast.success(), toast.error(), toast.warning(), toast.info(), or toast.show().
 * The ref is set by ToastProvider when the app mounts.
 * Second argument is optional title (string). If an options object is passed by mistake (e.g. { autoClose, position }), it is ignored to avoid React error #31.
 */

let toasterRef = null;

export function setToasterRef(ref) {
  toasterRef = ref;
}

/** Use second arg as title only if it's a string; ignore options objects to avoid rendering them (React #31). */
function normalizeTitle(title) {
  if (title == null || typeof title === 'string') return title;
  if (typeof title === 'object' && (title.autoClose != null || title.position != null)) return undefined;
  return undefined;
}

export const toast = {
  show(options) {
    toasterRef?.current?.show?.(options);
  },

  success(message, title) {
    toast.show({
      message: message ?? '',
      title: normalizeTitle(title),
      variant: 'success',
      duration: 4000,
    });
  },

  error(message, title) {
    toast.show({
      message: message ?? '',
      title: normalizeTitle(title),
      variant: 'error',
      duration: 5000,
    });
  },

  warning(message, title) {
    toast.show({
      message: message ?? '',
      title: normalizeTitle(title),
      variant: 'warning',
      duration: 4000,
    });
  },

  info(message, title) {
    toast.show({
      message: message ?? '',
      title: normalizeTitle(title),
      variant: 'default',
      duration: 4000,
    });
  },

  /** Alias for warning (avoids "toast.warn is not a function" when code uses react-toastify style). */
  warn(message, title) {
    toast.warning(message, normalizeTitle(title));
  },
};
